import { CdkPortalOutlet } from '@angular/cdk/portal';
import { ChangeDetectionStrategy, Component, HostBinding, ViewEncapsulation } from '@angular/core';
import { modalAnimations } from '@df/ui/modal/modal-animations';
import { ModalContainerAbstract } from '@df/ui/modal/modal-container.abstract';

/**
 * Internal component that wraps user-provided bottom modal content.
 */
@Component({
    selector: 'modal-bottom-container',
    template: `<ng-template cdkPortalOutlet />`,
    styleUrl: './modal-container.scss',
    changeDetection: ChangeDetectionStrategy.OnPush,
    encapsulation: ViewEncapsulation.None,
    animations: [modalAnimations.modalBottomContainer],
    host: {
        class: 'modal-container modal-bottom-container',
        tabindex: '-1',
        'aria-modal': 'true',
        '[attr.id]': 'id',
        '[attr.role]': 'config.role',
        '[attr.aria-labelledby]': 'config.ariaLabel ? null : ariaLabelledBy',
        '[attr.aria-label]': 'config.ariaLabel',
        '[attr.aria-describedby]': 'config.ariaDescribedBy || null',
        '(@modalBottomContainer.start)': 'onAnimationStart($event)',
        '(@modalBottomContainer.done)': 'onAnimationDone($event)'
    },
    standalone: true,
    imports: [CdkPortalOutlet]
})
export class ModalBottomContainerComponent extends ModalContainerAbstract {
    @HostBinding('@modalBottomContainer') get getModalContainer(): any {
        return this.animationState;
    }
}
